// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + chunkId + "." + {"ntg-posttvgo_dist_components_footer_FooterContent_js": "fb54b7fb","ntg-posttvgo_dist_index_js": "e2bdb2ea","ntg-posttvgo_dist_themes_base_css": "cef4776d","src_components_npvrManagement_NpvrManagement_js": "6a8c6669","src_components_settings_AppSettings_js": "f0df9a9b","src_helpers_gaming_cgxclient_min_js": "922ef0dc","src_helpers_gaming_sgxsessiontracker_min_js": "72f843c7",}[chunkId] + ".js"
}